import {fork, all, } from "redux-saga/effects";
import profileSaga from "./profileSaga";
import videosSaga from "./videosSaga";

function* mySaga() {
    yield all([
        fork(profileSaga),
        fork(videosSaga),
    ])
}

export default mySaga;
